import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/elizabethrogers/websites/beth-gatsby-blog/src/templates/page.tsx";
import { FormContact } from "../components/";
export const pageProps = {
  title: "Contact Me",
  metaTitle: "Contact Me",
  keywords: ["contact", "Elizabeth Rogers"],
  css: {
    maxWidth: "1024px",
    margin: "auto"
  }
};
export const _frontmatter = {};
const layoutProps = {
  pageProps,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <FormContact mdxType="FormContact" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      